<template>
  <div
    class="table-ellipsis"
  >
    <div
      class="table-ellipsis__text"
    >
      <slot />

      <a
        :href="href"
        class="table-ellipsis__name linked-name"
        target="_blank"
        :title="title"
        v-bind="$attrs"
      >
        <slot name="link-content">
          {{ title }}
        </slot>
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    href: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
});
</script>
